  @if (this.npsSurveyService.surveyVisible) {
    <div><app-survey-monkey [surveyUrl] = 'this.npsSurveyService.surveyUrl' (close)="closeSurveyComponent()" [userData]="userDetails" [region]="region"></app-survey-monkey></div>
  }
<div [dir]="direction">
  @if (!isMobile && !showNavigationPopup) {
    <router-outlet></router-outlet>
  }
  @if (showSpinner) {
    <div class="ct-overlay">
      <app-spinner></app-spinner>
    </div>
  }
</div>
@if (isMobile || showNavigationPopup) {
  <div class="get-mobile-app">
    <div class="column-align-center">
      <img src="assets/images/holcim-plus-logo.svg" alt="" />
      @if (showNavigationPopup) {
        <p class="get-mobile-app-msg">
          {{ "WeveMovedToANewLink" | translate }} :
          <a href="javascript:void(0)" (click)="NavigateToAWS('anchor')">{{
            "https://web.clickitapp.io"
          }}</a>
          {{ "PleaseBookmarkTheNewLink" | translate }}
        </p>
      }
      @if (isMobile) {
        <p class="get-mobile-app-msg">
          {{
            "SorryTheHolcimWebAppIsNotOptimizedForMobilePhoneScreensButWeDoHaveMobileAppsDesignedSpeciallyForBothAndroidAndIPhonesOnGooglePlayStoreAndAppleAppStoreRespectively"
              | translate
          }}
        </p>
      }
      @if (isMobile) {
        <div class="row-align-center">
          <a href="https://apps.apple.com/us/app/clickit/id1615341953"
            ><img class="app-on-icon" src="assets/images/app-store.svg" alt=""
          /></a>
          <a
            href="https://play.google.com/store/apps/details?id=com.holcim.navendor"
            ><img
              class="app-on-icon"
              src="assets/images/google-play.svg"
              alt=""
          /></a>
        </div>
      }
      @if (showNavigationPopup) {
        <div class="row-align-center">
          <button class="act-btn-dark" (click)="NavigateToAWS('button')">
            {{ "GoThereNow" | translate }}
          </button>
        </div>
      }
    </div>
  </div>
}
@if (showError) {
  <div>
    <app-error-modal></app-error-modal>
  </div>
}

<app-update-app-modal [updatedStaus]="versionUpadted"></app-update-app-modal>
<!-- migration popup -->
@if (isClickitUser) {
  <div class="ct-overlay migarion-pop-common-overlay">
    <div
      class="modal-position"
      animate.enter="modal-enter"
      animate.leave="modal-leave"
    >
      <div class="ct-modal migarion-pop-common">
        <div class="ct-mdl-cont">
          <div class="migarion-pop-content-common">
            <img
              src="assets/images/holcim-plus-logo.svg"
              alt=""
              class="logo-white-filter"
            />
            <div class="ct-mdl-wrap">
              <p class="clickit-migarion-subtext-common">
                {{ "ThisAppIsNotAvailableForYou" | translate }}
              </p>
              <p class="clickit-migarion-subtext-small-common">
                {{ "PleaseContinueOn" | translate }}
                <span class="clickit-migarion-subtext-small-common-bold"
                  >Clickit</span
                >
                {{ "ToEnjoyTheSameHighQualityServiceAndMore" | translate }}
              </p>

              <div class="hzvt-item-center hzvt-item-center modal-foot-btns">
                <button
                  class="btn-dark-migarion-common"
                  (click)="movetoClickit($event)"
                >
                  {{ "ContinueOn" | translate }} Clickit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<!-- migration popup -->

@if (enableSentry) {
  <button class="feedback-button" id="feedback">Report Issue</button>
}

